// extracted by mini-css-extract-plugin
export var darkBlue = "#003e52";
export var darkGreen = "#3b693d";
export var green = "#3dae2b";
export var lightGreen = "#93d500";
export var newsGreen = "#ecf5d7";
export var orange = "#f90";
export var yellow = "#fbc900";
export var paleBlue = "#64a1bb";
export var blue = "#67b9e8";
export var blueishGrey = "#adc6d6";
export var coolGrey = "#e1e2e0";
export var white = "#fff";
export var almostWhite = "#f2eded";
export var lightGrey = "#d3d3d3";
export var lightishGrey = "#aba9a9";
export var grey = "#828382";
export var darkishGrey = "#666";
export var darkGrey = "#4b4d4b";
export var almostBlack = "#333";
export var error = "#ff3a3a";
export var warning = "#ffd162";
export var success = "#1ebc7b";
export var container = "ContactBlock-module--container--qU9cq";
export var imageAndInfosBox = "ContactBlock-module--imageAndInfosBox--2k0_Z";
export var image = "ContactBlock-module--image--1aTAV";
export var infosSideBox = "ContactBlock-module--infosSideBox--21BPK";
export var infoRow = "ContactBlock-module--infoRow--1Xwoj";
export var hidden = "ContactBlock-module--hidden--yAlvp";
export var infoBlock = "ContactBlock-module--infoBlock---b8jW";
export var singleEntryRow = "ContactBlock-module--singleEntryRow--3Y3-S";
export var label = "ContactBlock-module--label--3VsrU";
export var info = "ContactBlock-module--info--1LSKf";
export var infoContact = "ContactBlock-module--infoContact--2g4Qg";